module.exports = "/hwa/_next/static/images/bin-bags-7336525f12422e89d0e353dda73b3be8.png";